"use strict";

var _interopRequireDefault = require("/var/jenkins_home/workspace/sihong_test_front_mall/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.regexp.to-string");
require("core-js/modules/es7.string.pad-start");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.object.keys");
require("core-js/modules/es6.regexp.search");
var _objectSpread2 = _interopRequireDefault(require("/var/jenkins_home/workspace/sihong_test_front_mall/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
require("core-js/modules/es6.regexp.split");
var _Pagination = _interopRequireDefault(require("@/components/Pagination"));
var _multiLanguageDisplay = require("@/utils/multiLanguageDisplay");
var _houseDetail = _interopRequireDefault(require("@/components/wareHouse/houseDetail.vue"));
var _warehouse = require("@/api/warehouse");
var _auth = require("@/utils/auth");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    Pagination: _Pagination.default,
    HouseDetail: _houseDetail.default
  },
  data: function data() {
    return {
      multiLanguageDisplay: _multiLanguageDisplay.multiLanguageDisplay,
      search: {
        goodsName: '',
        styleNo: '',
        color: '',
        size: '',
        category: ''
      },
      list: [],
      listLoading: true,
      total: 0,
      pageNo: 1,
      pageSize: 10
    };
  },
  created: function created() {},
  mounted: function mounted() {
    this.getList();
  },
  methods: {
    getImg: function getImg(src) {
      try {
        return src.split(',')[0];
      } catch (error) {
        return src;
      }
    },
    lookDetail: function lookDetail(row) {
      this.getListDetail(row.productId);
    },
    getListDetail: function getListDetail(productId) {
      var _this = this;
      var data = {
        productId: productId
      };
      (0, _warehouse.inventoryDetailApi)(data).then(function (data) {
        var res = data.data;
        if (res.errno == 0) {
          _this.$refs.houseDetail.open(res.data);
        }
      });
    },
    // 查找
    onSearch: function onSearch() {
      this.pageNo = 1;
      this.getList();
    },
    onClear: function onClear() {
      this.search = {
        goodsName: '',
        styleNo: '',
        color: '',
        size: '',
        category: ''
      };
      this.pageNo = 1;
      this.getList();
    },
    // 进入详情
    toDetail: function toDetail() {
      this.$router.push('/wareHouse/houseListDetail');
    },
    // 获取列表数据
    getList: function getList(val) {
      var _this2 = this;
      console.log(val);
      this.listLoading = true;
      var params = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, this.search), {}, {
        pageNo: this.pageNo,
        pageSize: this.pageSize
      });
      (0, _warehouse.inventoryListApi)(params).then(function (data) {
        var res = data.data;
        if (res.errno == 0) {
          _this2.listLoading = false, _this2.list = res.data.list;
          _this2.total = res.data.total;
        }
      });
    },
    // 导出库存数据
    handleExport: function handleExport() {
      var _this3 = this;
      this.$message.info('正在导出数据，请稍候...');

      // 构建与查询相同的参数
      var params = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, this.search), {}, {
        pageNo: this.pageNo,
        pageSize: this.pageSize
      });

      // 构建查询字符串
      var queryString = Object.keys(params).map(function (key) {
        return "".concat(encodeURIComponent(key), "=").concat(encodeURIComponent(params[key] || ''));
      }).join('&');

      // 构建完整URL
      var url = "".concat(process.env.VUE_APP_BASE_API, "/goods/inventory/export?").concat(queryString);

      // 创建XMLHttpRequest对象
      var xhr = new XMLHttpRequest();
      xhr.open('GET', url, true);
      xhr.responseType = 'blob';
      xhr.setRequestHeader('Mu-Token', (0, _auth.getToken)());
      xhr.onload = function () {
        if (xhr.status === 200) {
          // 请求成功
          var blob = xhr.response;
          var contentType = xhr.getResponseHeader('Content-Type') || 'application/vnd.ms-excel';

          // 创建下载链接
          var link = document.createElement('a');
          link.href = URL.createObjectURL(blob);

          // 获取当前日期作为文件名的一部分
          var date = new Date();
          var dateString = "".concat(date.getFullYear()).concat((date.getMonth() + 1).toString().padStart(2, '0')).concat(date.getDate().toString().padStart(2, '0'));

          // 设置下载文件名
          link.download = "\u5E93\u5B58\u6570\u636E_".concat(dateString, ".xlsx");
          document.body.appendChild(link);

          // 触发点击事件，开始下载
          link.click();

          // 清理
          URL.revokeObjectURL(link.href);
          document.body.removeChild(link);
          _this3.$message.success('导出成功');
        } else {
          // 请求失败
          _this3.$message.error("\u5BFC\u51FA\u5931\u8D25: ".concat(xhr.statusText));
        }
      };
      xhr.onerror = function () {
        _this3.$message.error('导出失败，请检查网络连接');
      };

      // 发送请求
      xhr.send();
    }
  }
};